import { SortDirection } from '@air/api/types';

const sortWithAscDefault = ['name', 'firstName', 'lastName', 'size', 'ext', 'type'];

export const getDefaultSortDirection = (fieldName: string) =>
  sortWithAscDefault.includes(fieldName) ? SortDirection.asc : SortDirection.desc;
